<template>
  <div class="estimate-note">
    <ul>
      <li>※表示価格は、{{priceDate}}現在の情報です。</li>
      <li>※現金販売価格は消費税{{tax}}％込み価格です。</li>
      <li>※自賠責保険料は、新規加入（自家用）の場合の金額です。<br>また、離島については、保険料が異なる場合があります。</li>
      <li>※登録などに伴う費用に含まれる手続代行費用は地域によって異なります</li>
      <li>※オプション、アクセサリー等は予告なく販売中止や仕様、価格の変更をする場合があります。<br>また、商品によってはお届けまでお時間がかかる場合がございます。</li>
      <li>※一部の写真は海外仕様車も含まれます。</li>
      <li>※オプション等の表示価格には取付工賃等は含まれていない場合がございます。</li>
      <li>※作成されたお見積書は参考価格です、実際の金額とは異なる場合がございます。詳しくは店舗スタッフまでお問合わせ下さい。</li>
      <li
        v-for="note in extendedNotes"
        v-html="note"
      />
    </ul>

    <p><img src="https://honda-dream-japan.co.jp/wp-content/uploads/2024/06/2rinlogo.png" alt="">(一社)自動車公正取引協議会・会員</p>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: 'EstimateNote',
  components: {},
  props: {
    extendedNotes: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    let tax = ref(10) // 消費税
    let priceDate = ref('') // 表示価格の日付

    return {
      tax,
      priceDate
    }
  },
  mounted() {
    const json = JSON.parse(document.querySelector('[data-estimate-meta]').textContent)
    this.tax = json.tax
    this.priceDate = json['price_date']
  }
})

</script>